import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing exponential functions.
 * Focus: Exponential curve with asymptote visualization.
 */
export const EXPONENTIAL_PRESET: GraphpadWidgetConfig = {
  id: 'exponential',
  type: 'graphpad',
  params: {
    f: {
      type: 'exponential',
      params: { a: 1, b: 2, h: 0, k: 0 },
    },
    'f-asymptotes': {
      type: 'asymptotes',
      params: { of: 'f' },
    },
    'f-yintercept': {
      type: 'yIntercept',
      params: { of: 'f' },
    },
    secant: {
      type: 'secant',
      params: { of: 'f', xStart: 1, xEnd: 2, finite: false, showRateTriangle: true },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -5, xEnd: 5, yStart: -2, yEnd: 10 },
      grid: { type: 'lines', visible: false },
    },
    elements: {
      'f-yintercept': {
        point: { label: { contentVariant: 'name+coord', position: 'topLeft' } },
      },
      secant: {
        subparts: {
          rateTriangle: {
            visible: true,
            subparts: {
              horizontalLine: {
                line: {
                  label: { text: 'Δx = {length}', position: 'bottom', color: 'pink', variant: 'secondary' },
                },
              },
              verticalLine: {
                line: {
                  label: { text: 'Δy = {length}', position: 'right', color: 'pink', variant: 'secondary' },
                },
              },
              cornerPoint: { visible: false },
            },
          },
        },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'a (scale)',
        param: 'f.a',
        range: [-3, 3, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'purple',
      },
      {
        id: 'slider-b',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'b (base)',
        param: 'f.b',
        range: [0.1, 5, 0.1],
        defaultValue: 2,
        editable: true,
        color: 'indigo',
      },
      {
        id: 'slider-h',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'h (x-shift)',
        param: 'f.h',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-k',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'k (y-shift)',
        param: 'f.k',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'amber',
      },
    ],
  },
};
